import { Box, Grid, Breadcrumbs, Link, Typography, MenuItem, TextField, Button } from "@mui/material";
import { useSelector } from "react-redux";
import { useState } from "react";
import moment from "moment";
import ReportTable, { RRow, RCell } from "components/Tables/ReportTable";
import { useLocation, useNavigate } from "react-router-dom";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { useGetLedgerTransactions } from "api/hooks/accounting";


export default function LedgerTransactionsTable ({ embedded = false, ledgerId: propLedgerId, ledgerName: propLedgerName }) {
  const location = useLocation()
  const business_branch_id = useSelector((state) => state.authReducer.business_branch_id);
  const navigate = useNavigate()
  const [showFiter, setShowFilter] = useState(false);
  const [startDate, setStartDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().endOf("month").format("YYYY-MM-DD"));

  const ledger_name = embedded ? propLedgerName : location.state?.name;
  const ledger_id = embedded ? propLedgerId : location.state?.id;

  const {ledgerTransactions, isLoadingLedgerTransactions} = useGetLedgerTransactions(business_branch_id, ledger_id);

  const handleChangePeriodFilter = async (e) => {
    if (e.target.value === "THIS MONTH") {
      setStartDate(moment().startOf("month").format("YYYY-MM-DD"));
      setEndDate(moment().endOf("month").format("YYYY-MM-DD"));
      setShowFilter(false);
    }
    if (e.target.value === "THIS WEEK") {
      setStartDate(moment().startOf("week").format("YYYY-MM-DD"));
      setEndDate(moment().endOf("week").format("YYYY-MM-DD"));
      setShowFilter(false);
    }
    if (e.target.value === "TODAY") {
      setStartDate(moment().format("YYYY-MM-DD"));
      setEndDate(moment().format("YYYY-MM-DD"));
      setShowFilter(false);
    }
    if (e.target.value === "CUSTOM") {
      setShowFilter(true);
    }
  };

  const handleClickFilter = () => {
    // Period selection above already updates startDate/endDate.
  };
    
  return (
    <Box>
      {!embedded && (
        <Breadcrumbs sx={{ padding: "20px" }} aria-label="breadcrumb">
          <Link
            underline="hover"
            sx={{ display: "flex", alignItems: "center" }}
            color="inherit"
            onClick={() => navigate("/accounting")}
          >
            <AccountBalanceIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            Accounting
          </Link>
          <Typography
            sx={{ display: "flex", alignItems: "center" }}
            color="text.primary"
          >
            <b>{ledger_name}</b>
          </Typography>
        </Breadcrumbs>
      )}
      {!embedded && <Box p="1rem" m="1rem" borderRadius="0.5rem">
        <Grid container spacing={4} className="alignHorizantal">
          <Grid xs={6}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                mx: "4px",
              }}
            >
              <h4>REPORT PERIOD:</h4>

              <TextField
                label="PERIOD"
                select
                defaultValue="THIS MONTH"
                size="small"
                onChange={(e) => {
                  handleChangePeriodFilter(e);
                }}
                sx={{
                  minWidth: 50,
                  maxWidth: 300,
                  m: "10px",
                  backgroundColor: "white",
                }}
              >
                <MenuItem value="THIS WEEK">THIS WEEK</MenuItem>
                <MenuItem value="TODAY">TODAY</MenuItem>
                <MenuItem value="THIS MONTH">THIS MONTH</MenuItem>
                <MenuItem value="CUSTOM">CUSTOM</MenuItem>
              </TextField>

              {showFiter ? (
                <>
                  <TextField
                    label="Start Date"
                    type="date"
                    defaultValue={startDate}
                    size="small"
                    onChange={(e) => setStartDate(e.target.value)}
                    sx={{
                      m: "10px",
                      backgroundColor: "white",
                    }}
                  />
                  <TextField
                    label="End Date"
                    type="date"
                    defaultValue={endDate}
                    size="small"
                    onChange={(e) => setEndDate(e.target.value)}
                    sx={{
                      m: "10px",
                      backgroundColor: "white",
                    }}
                  />
                </>
              ) : null}
              <Button
                variant="contained"
                size="small"
                sx={{
                  m: "9px",
                }}
                onClick={() => handleClickFilter()}
              >
                FILTER
              </Button>
            </Box>
          </Grid>
          <Grid xs={3}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                // m: "4px",
              }}
            >
              <h4>FILTER BY ACTION:</h4>
              <TextField
                label={"ACTION"}
                defaultValue={"all"}
                select
                size="small"
                sx={{
                  minWidth: 50,
                  maxWidth: 300,
                  m: "10px",
                  backgroundColor: "white",
                }}
              >
                <MenuItem value="all">ALL</MenuItem>
                <MenuItem value="CREDIT">CREDIT</MenuItem>
                <MenuItem value="DEBIT">DEBIT</MenuItem>
              </TextField>
            </Box>
          </Grid>
          <Grid xs={3}></Grid>
        </Grid>
      </Box>}

      <ReportTable
        columns={[
          { label: "Date Carried Out", width: 50 },
          { label: "Memo", width: 150 },
          { label: "Amount", width: 150 },
          { label: "Transaction Type" },
          { label: "Done By" },
        ]}
        rows={ledgerTransactions}
        loading={isLoadingLedgerTransactions}
        emptyMessage="No data found"
        renderRow={(row, index) => (
          <RRow key={row.id ?? index} index={index}>
            <RCell>{moment(row.posted_on).format("LLL")}</RCell>
            <RCell>{row.memo}</RCell>
            <RCell>{row.transaction_amount}</RCell>
            <RCell>{row.ledger_side}</RCell>
            <RCell>
              {row.posted_by.first_name}{" "}
              {row.posted_by.last_name}
            </RCell>
          </RRow>
        )}
      />
    </Box>
  );
};
